import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';
import _ from 'lodash';

const CARDS_PER_GROUP = 5;

const fetchCategoryCards = async (categoryId) => {
  try {
    let query = supabase
      .from("cards")
      .select(`
        id,
        companyname,
        category_id
      `)
      .order('companyname', { ascending: true });

    // Si no es "All" (id: 9), filtrar por categoría
    if (categoryId !== 9) {
      query = query.eq('category_id', categoryId);
    }

    const { data, error } = await query;
    if (error) throw error;

    return data;
  } catch (error) {
    throw error;
  }
};

export function useDiscoverSubCategories({ 
  componentSize = "Desktop 1440",
  selectedCategoryId = 9,
  excludeCardId = ""
}) {
  const { data: cards = [], isLoading, error } = useQuery({
    queryKey: queryKeys.cards.byCategory(selectedCategoryId),
    queryFn: () => fetchCategoryCards(selectedCategoryId),
    staleTime: 1000 * 60 * 5, // 5 minutos
    cacheTime: 1000 * 60 * 30, // 30 minutos
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  // Procesar cards y organizar en grupos
  const processedData = React.useMemo(() => {
    // Filtrar card excluida si existe
    const filteredCards = excludeCardId 
      ? cards.filter(card => card.id !== excludeCardId)
      : cards;

    // Agrupar cards en grupos de 5
    const cardGroups = _.chunk(filteredCards, CARDS_PER_GROUP);

    // Obtener ancho del contenedor según tamaño
    const getContainerWidth = () => {
      switch (componentSize) {
        case "Phone":
          return 362.4;
        case "Tablet":
          return 626;
        case "Desktop 1200":
          return 1057;
        case "Desktop 1440":
        default:
          return 1210;
      }
    };

    return {
      cardGroups,
      containerWidth: getContainerWidth()
    };
  }, [cards, excludeCardId, componentSize]);

  return {
    cardGroups: processedData.cardGroups,
    containerWidth: processedData.containerWidth,
    isLoading,
    error
  };
}